import React, { useState } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  Select, MenuItem, Checkbox, ListItemText, Stack, Typography, IconButton,
  
} from "@mui/material";
import { IconFileDescription } from '@tabler/icons-react';
import { tableCellClasses } from '@mui/material/TableCell';
import DeleteIcon from "@mui/icons-material/Delete";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import HeaderMMS from '../header/header';
import MenuMMS from '../menu/menu';
import { Add } from "@mui/icons-material";

// iOS style switch



const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',

    // ✅ When ON, knob stays on left
    '&.Mui-checked': {
      transform: 'translateX(0px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#4caf50', // green
        opacity: 1,
        border: 0,
      },
    },

    // ✅ When OFF, knob moves to right
    '&:not(.Mui-checked)': {
      transform: 'translateX(16px)',
      '& + .MuiSwitch-track': {
        backgroundColor: '#ccc', // gray
        opacity: 1,
        border: 0,
      },
    },

    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },

  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },

  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));


// Sample options for dropdown
const dropdownOptions = [
  "Company",
  "Location",
  "Department",
  "Area",
  "Plan / Facility",
  "Equipment",
  "Equipment Type",
  "Equipment Capacity",
  "Equipment Tag",
  "Sub - Equipment",
  "Sub - Equipment Tag",
  "Device / Instruction",
  "Device / Inst Tag",
  "Work Permit",
  "Job Native",
  "Job Priority",
  "Job Status",
  "Order Type",
  "Vendor Creation",
  "Created By User Creation",
  "Reported By User Creation",
  "Attended By User Creation",
  "Employee Creation",
  "User Role Creation"
];


// Helper to create row
function createData(id, name, status) {
  return { id, name, status };
}

export default function UserTable() {
 const initialRows = [
  { id: 1, name: "Admin", status: true },
  { id: 2, name: "Guest", status: false },
  { id: 3, name: "Super Admin", status: true },
  { id: 4, name: "User", status: false }
];

const [rows, setRows] = useState(initialRows);

   const [open, setOpen] = React.useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);



  const handleAddNew = () => {
    setOpenDialog(true);
  };

  const handleSaveNew = () => {
    if (selectedOptions.length > 0) {
      setRows((prev) => [
        ...prev,
        ...selectedOptions.map((name, index) =>
          createData(prev.length + index + 1, name, true)
        ),
      ]);
    }
    setSelectedOptions([]);
    setOpenDialog(false);
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setDeleteConfirmOpen(true);
  };

  const confirmDelete = () => {
    setRows((prev) => prev.filter((row) => row.id !== deleteId));
    setDeleteConfirmOpen(false);
    setDeleteId(null);
  };
    const handleClose = () => {
    setOpenDialog(false);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };
   const headerProps = {
    open, handleDrawerOpen
  }
  const menuProps = {
    setOpen, open
  }
 const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const handleSwitchChange = (id) => {
    setRows(prev =>
      prev.map(row =>
        row.id === id ? { ...row, status: !row.status } : row
      )
    );
  };

  const handleExport = () => {
    const headers = ["ID", "Name", "Status"];
    const csvRows = [
      headers.join(","), // header row
      ...rows.map(row => [
        row.id,
        row.name,
        row.status ? "On" : "Off"
      ].join(","))
    ];

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "UserRoles.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  };
  return (
    <Box sx={{ display: 'flex' }}>

      <HeaderMMS {...headerProps} />
      <MenuMMS {...menuProps} />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }} className='bg-slate-100'>
        <Grid className='bg-slate-100 '>
          <DrawerHeader />

          <div className='rounded p-3 text-lg text-left font-semibold'>
            <h2>User Roles</h2>
          </div>
           <div className='text-left bg-white  m-2 border-solid border rounded'>
          <div className='border-slate-300 rounded-md  flex bg-gray-200'>
                    <h3 className='border-b-2  p-2  '>User Roles List</h3>
                    <div className="ml-auto">
<Button variant="contained"  onClick={handleAddNew}  startIcon={<Add />}>
        Add New
      </Button>
      <Button variant="contained"  sx={{marginLeft:'5px'}} onClick={handleExport} startIcon={<IconFileDescription />}>
          Export
        </Button>
                    </div>
                    
                  </div>
           <Box className="w-full p-3">
            <Grid className='bg-slate-100 ' xs={12} md={12}>
      

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ p:1 }}>S.No</StyledTableCell>
              <StyledTableCell sx={{ p:1 }}>Role</StyledTableCell>
              <StyledTableCell sx={{ p:1 }}>Status</StyledTableCell>
              <StyledTableCell sx={{ p:1 }}>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <StyledTableRow  key={row.id}>
                <StyledTableCell sx={{ p:1 }}>{row.id}</StyledTableCell >
                <StyledTableCell sx={{ p:1 }}>{row.name}</StyledTableCell >
                <StyledTableCell sx={{ p:1 }}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    
                    <IOSSwitch
                      checked={row.status}
                      onChange={() => handleSwitchChange(row.id)}
                      color="success"
                    />
                     {row.status ? "On" : "Off"}
                  </Stack>
                </StyledTableCell >
                <StyledTableCell >
                  <IconButton color="error" onClick={() => handleDeleteClick(row.id)}>
                    <DeleteIcon />
                  </IconButton>
                </StyledTableCell >
              </StyledTableRow >
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      
      </Grid>
      </Box>
</div>
      {/* Add New Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} PaperProps={{
    sx: { minWidth: { xs: '90%', sm: 400, md: 600 } } // responsive min width
  }}>
        <DialogTitle> User Role</DialogTitle>
        <DialogContent>
          <Select
            multiple
            fullWidth
            value={selectedOptions}
            onChange={(e) => setSelectedOptions(e.target.value)}
            renderValue={(selected) => selected.join(", ")}
          >
            {dropdownOptions.map((option) => (
              <MenuItem key={option} value={option}>
                <Checkbox checked={selectedOptions.indexOf(option) > -1} />
                <ListItemText primary={option} />
              </MenuItem>
            ))}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveNew}>Save</Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteConfirmOpen} onClose={() => setDeleteConfirmOpen(false)}>
        <DialogTitle>Are you sure you want to delete this user role?</DialogTitle>
        <DialogActions>
          <Button onClick={() => setDeleteConfirmOpen(false)}>Cancel</Button>
          <Button variant="contained" color="error" onClick={confirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      </Grid>
    </Box>
  </Box>
  );

}
